import React from "react";
import { formatDate } from "../season";

/** Shown instead of the form before registration opens and after the deadline */
const SeasonNotice = ({ season }) => {
  const upcoming = season.status === "upcoming";
  return (
    <div className="h-full flex flex-col items-center justify-center text-center p-6">
      <div className="text-5xl mb-4" aria-hidden="true">{upcoming ? "🗓️" : "🔒"}</div>
      <h2 className="text-xl font-bold uppercase mb-2">
        {upcoming ? "Registration opens soon" : "Registration is closed"}
      </h2>
      {season.year ? (
        <p className="text-lg text-gray-700">
          {upcoming
            ? `Registration for the ${season.title} opens on ${formatDate(season.opensOn)}.`
            : `Registration for the ${season.title} closed on ${formatDate(season.deadline)}.`}
        </p>
      ) : (
        <p className="text-lg text-gray-700">Please check back later.</p>
      )}
      {season.assistanceEmail && (
        <p className="mt-6 text-gray-600">
          For registration assistance: <a className="text-blue-700 underline" href={`mailto:${season.assistanceEmail}`}>{season.assistanceEmail}</a>
        </p>
      )}
    </div>
  );
};

export default SeasonNotice;
